export class Gpsdata {
    public VehicleNo!: string;
    public LastTime!: string;
    public DriverName!: string;
    public Speed!: string;
    public Place!: string;
    public Latitude!: number;
    public Status!: string;
    public Longitude!: string;
}